// extracted by mini-css-extract-plugin
module.exports = {"login-container":"App_login-container__xhX4_","app":"App_app__dgZy-"};